var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"\n\t\t13.4,8 9.4,6 9.4,8 9.4,10 \t","key":0}),React.createElement("line",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","x1":"9.4","y1":"8","x2":"2.6","y2":"8","key":1})]));
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Arrow;

Arrow.default = Arrow;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/arrow.svg
// module id = ../icon/src/icons/arrow.svg
// module chunks = 0